export const colors = {
  white: "#fff",
  grey: "#6B6B6B",
  darkBlue: "#083F75",
};
